var _defs, _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibraLogomark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1025.22 1025.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 55.22px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m883.43,997.61H141.72c-63.05,0-114.11-51.13-114.11-114.25v-.42c0-50.3,32.5-92.98,77.6-108.22-48.64-75.59-76.84-165.66-76.84-262.18C28.37,244.75,245.17,27.61,512.61,27.61s484.24,217.14,484.24,484.93c0,96.58-28.2,186.66-76.84,262.18,45.1,15.24,77.6,57.92,77.6,108.22v.42c0,63.12-51.13,114.25-114.11,114.25h-.07Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m285.85,511.9c-39.08,0-70.81,31.73-70.81,70.81s31.73,70.81,70.81,70.81,70.81-31.73,70.81-70.81-31.73-70.81-70.81-70.81Zm-27.3,70.81c-14.9,0-27.02-12.12-27.02-27.02s12.12-27.02,27.02-27.02,27.02,12.12,27.02,27.02-12.12,27.02-27.02,27.02Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 258.85,
    cy: 555.61,
    r: 27
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m743.85,511.9c-39.08,0-70.81,31.73-70.81,70.81s31.73,70.81,70.81,70.81,70.81-31.73,70.81-70.81-31.73-70.81-70.81-70.81Zm-27.3,70.81c-14.9,0-27.02-12.12-27.02-27.02s12.12-27.02,27.02-27.02,27.02,12.12,27.02,27.02-12.12,27.02-27.02,27.02Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 716.85,
    cy: 555.61,
    r: 27
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraLogomark);
export default __webpack_public_path__ + "static/media/libra-logo.mark.1675eebb5a7f907401fee2926e0cbfd7.svg";
export { ForwardRef as ReactComponent };